export enum ProductType {
  Subscription = 'Subscription',
  Consumable = 'Consumable',
  NonConsumable = 'NonConsumable'
}
